"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var init = function (args, errorLog) {
    // wx.onError不支持在插件中使用，所以小程序用户需要自己在小程序中设置监听
    // wx.onError = function (error: any) {
    //     errorLog(
    //         `===wx.onError===
    //         message:${error}`
    //     )
    // }
};
exports.default = init;
